module.exports = __webpack_public_path__ + "static/media/hotel_ct.ff31dac9.png";